export default "__VITE_ASSET__6ViJgwet__"